"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/footerSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionIconsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Facebook" | "Twitter" | "LinkedIn" | "Instagram" */
    ariaLabel: string;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-linkedin-in" | "fa-brands fa-instagram" */
    className: string;
    /** Detected variants: "icon" */
    aClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Modern Centers" | "Better Everyday Health" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h30ClassName?: string;
};

type FooterSection336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-lg-2" | "col-lg-3 col-md-3 col-sm-6" | "col-lg-3 col-md-4 col-sm-6" | "col-lg-4 col-md-5" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "logo" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/logo-16.svg" */
    src?: string;
    /** Detected variants: "footer-logo" | "footer-widget" */
    div0ClassName: string;
    /** Detected variants: "footer-subscribe" */
    div0ClassName2?: string;
    /** Detected variants: "Subscribe" */
    ariaLabel?: string;
    /** Detected variants: "btn-icon btn-primary" */
    button0ClassName?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "form-control" */
    input0ClassName?: string;
    /** Detected variants: "Enter Email Address" */
    placeholder?: string;
    /** Detected variants: "Expert insights, health tips, and important updates to help you breathe easier, hear clearly" */
    p0Text?: ReactNode;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "Quick" | "Our" | "Get in" */
    h20Text?: ReactNode;
    /** Detected variants: "footer-title" */
    h20ClassName?: string;
    /** Detected variants: "Links" | "Solutions" | "Touch" */
    span0Text?: ReactNode;
    /** Detected variants: "#" */
    div0div0form0Action?: string;
    /** Detected variants: "submit" */
    div0div0form0button0Type?: string;
    /** Detected variants: "email" */
    div0div0form0input0Type?: string;
    footerMenuItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Courses" | "Services" | "Specialities" | "Clinics" | "Weight Manage Programs" | "Personalized Nutrition Plans" | "Healthy Lifestyle Coaching" | "Group Wellness Programs" | "Dietitian Consultations" */
    a0Text: ReactNode;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "icon" */
    className?: string;
};
export type HomeSixteenFooterSectionGeneratedProps = {
    divDiv0H20H2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h2">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    footerDiv0Div0ClassName?: string;
    /** Default: "Copyright &copy; 2026" */
    footerDiv0Div1P0PText?: ReactNode;
    /** Default: ". All Rights Reserved" */
    footerDiv0Div1P0PText2?: ReactNode;
    /** Default: "#" */
    footerDiv0Div1P0A0AHref?: string;
    /** Default: "Doccure" */
    footerDiv0Div1P0A0AText?: ReactNode;
    /** Default: "left" */
    footerDiv1DivDataDirection?: string;
    /** Default: "slow" */
    footerDiv1DivDataSpeed?: string;
    /** Default: "shadow" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/services-shadow-1.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/services-shadow-2.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerSectionIcons: FooterSectionIconsItem[];
    footerSectionServicesSlides: FooterSectionServicesSlidesItem[];
    footerSection336s: FooterSection336sItem[];
    footerSectionIconsItemWrapper?: (item: FooterSectionIconsItem, content: ReactNode) => ReactNode;
    footerSectionIconsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesItemWrapper?: (item: FooterSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    footerSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH3Visible?: boolean;
    footerSectionServicesSlidesH3Renderer?: (item: FooterSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    footerSection336sItemWrapper?: (item: FooterSection336sItem, content: ReactNode) => ReactNode;
    footerSection336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection336sH2Visible?: boolean;
    footerSection336sH2Renderer?: (item: FooterSection336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection336sH2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h2">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSixteenFooterSectionGenerated: FC<HomeSixteenFooterSectionGeneratedProps> = ({
    footerDiv0Div1P0A0AHref = "#",
    footerDiv0Div1P0A0AText = "Doccure",
    footerDiv0Div1P0PText = "Copyright &copy; 2026",
    footerDiv0Div1P0PText2 = ". All Rights Reserved",
    footerDiv1DivDataDirection = "left",
    footerDiv1DivDataSpeed = "slow",
    footerImageWithBasePath0ImageAlt = "shadow",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/services-shadow-1.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "shadow",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/services-shadow-2.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    divDiv0H20H2Props,
    divH30H3Props,
    footerDiv0Div0ClassName,
    footerSectionIcons,
    footerSectionServicesSlides,
    footerSection336s,
    footerSectionIconsItemWrapper,
    footerSectionIconsRenderer,
    footerSectionServicesSlidesItemWrapper,
    footerSectionServicesSlidesRenderer,
    footerSectionServicesSlidesH3Visible,
    footerSectionServicesSlidesH3Renderer,
    footerSectionServicesSlidesH3Props,
    footerSection336sItemWrapper,
    footerSection336sRenderer,
    footerSection336sH2Visible,
    footerSection336sH2Renderer,
    footerSection336sH2Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
}) => {
    return (
        <footer className="footer-sixteen position-relative">
            <div className="container">
                <div className={footerDiv0Div0ClassName ?? "row row-gap-5 justify-content-center"}>
                    {renderCollectionNode(
                        footerSection336s,
                        (item: FooterSection336sItem) => (
                            <div className={item.className} key={item.key}>
                                <div className={item.div0ClassName}>
                                    {renderItemNode(footerSection336sH2Visible, footerSection336sH2Renderer, item, (
                                        <h2 className={item.h20ClassName} {...(typeof footerSection336sH2Props === "function" ? footerSection336sH2Props(item) : (footerSection336sH2Props ?? {}))} {...(typeof divDiv0H20H2Props === "function" ? divDiv0H20H2Props(item) : (divDiv0H20H2Props ?? {}))}>
                                            {item.h20Text}
                                            <span>{item.span0Text}</span>
                                        </h2>
                                    ))}
                                    <ul className="footer-menu">
                                        {renderCollectionNode(
                                            item.footerMenuItems ?? [],
                                            (item: FooterSectionUlsItem) => (
                                                <li key={item.key}>
                                                    <a href={item.href ?? "#"}>
                                                        <span className={item.className ?? "icon"}></span>
                                                        {item.a0Text}
                                                    </a>
                                                </li>
                                            ),
                                            footerSectionUlsItemWrapper,
                                            footerSectionUlsRenderer
                                        )}
                                    </ul>
                                </div>
                            </div>
                        ),
                        footerSection336sItemWrapper,
                        footerSection336sRenderer
                    )}
                </div>
                <div className="footer-copyrights">
                    <p className="copyright">
                        {footerDiv0Div1P0PText}
                        <a href={footerDiv0Div1P0A0AHref}>{footerDiv0Div1P0A0AText}</a>
                        {footerDiv0Div1P0PText2}
                    </p>
                    <div className="social-icon">
                        {renderCollectionNode(
                            footerSectionIcons,
                            (item: FooterSectionIconsItem) => (
                                <a href={item.href ?? "#"} className={item.aClassName ?? "icon"} aria-label={item.ariaLabel} key={item.key}>
                                    <i className={item.className}></i>
                                </a>
                            ),
                            footerSectionIconsItemWrapper,
                            footerSectionIconsRenderer
                        )}
                    </div>
                </div>
            </div>
            <div className="horizontal-slide slide-sixteen three d-flex" data-direction={footerDiv1DivDataDirection} data-speed={footerDiv1DivDataSpeed}>
                <div className="slide-list d-flex">
                    {renderCollectionNode(
                        footerSectionServicesSlides,
                        (item: FooterSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(footerSectionServicesSlidesH3Visible, footerSectionServicesSlidesH3Renderer, item, (
                                    <h3 className={item.h30ClassName ?? "title"} {...(typeof footerSectionServicesSlidesH3Props === "function" ? footerSectionServicesSlidesH3Props(item) : (footerSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                        ),
                        footerSectionServicesSlidesItemWrapper,
                        footerSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid element-two" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeSixteenFooterSectionGenerated;
